import { SET_DEFINITIONS } from '../../data/sets';

/**
 * Displays active set bonuses for the currently equipped items.
 * Only renders if at least one set piece is equipped.
 *
 * Props:
 *  equipped — the equipped map
 */
export function SetBonusPanel({ equipped = {} }) {
  // Collect all sets that have at least 1 piece equipped
  const mainSlots = ['weapon', 'helmet', 'armor', 'ring1', 'ring2', 'gloves', 'boots', 'amulet'];
  const setCountMap = {};
  for (const slotId of mainSlots) {
    const item = equipped[slotId];
    if (item?.setId) {
      setCountMap[item.setId] = (setCountMap[item.setId] ?? 0) + 1;
    }
  }

  const setIds = Object.keys(setCountMap);
  if (setIds.length === 0) return null;

  return (
    <div className="set-bonus-panel">
      <p className="set-bonus-panel-title">Set Bonuses</p>
      {setIds.map(setId => {
        const def = SET_DEFINITIONS[setId];
        if (!def) return null;
        const count = setCountMap[setId];
        const totalPieces = def.bonuses[def.bonuses.length - 1].count;

        return (
          <div key={setId} className="set-bonus-entry">
            <div className="set-bonus-entry-name">
              ◆ {def.name} — {count}/{totalPieces}
            </div>
            {def.bonuses.map(bonus => {
              const isActive = count >= bonus.count;
              return (
                <div
                  key={bonus.count}
                  className={`set-bonus-row ${isActive ? 'set-bonus-row--active' : 'set-bonus-row--inactive'}`}
                >
                  {isActive ? '✦' : '○'} {bonus.count} pcs: {bonus.desc}
                </div>
              );
            })}
          </div>
        );
      })}
    </div>
  );
}
